import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { formSurfaceTheme } from './createAppTheme';
import { FormSurfaceContext } from './FormSurfaceContext';

export const FormSurfaceTheme: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <FormSurfaceContext.Provider value>
    <ThemeProvider theme={formSurfaceTheme}>{children}</ThemeProvider>
  </FormSurfaceContext.Provider>
);
